// extracted by mini-css-extract-plugin
module.exports = {"Light":"Theme__Light_2_koa","Dark":"Theme__Dark_2l824"};